/*eslint-disable*/
import React from 'react'
import { AppWrapper } from './AppWrapper'

export function AppRedirector(props: any) {
    const { app } = props.match.params
    return <AppWrapper {...props} app={app} />
}
